import { render, staticRenderFns } from "./VulListComponent.vue?vue&type=template&id=00424c8e&scoped=true&"
import script from "./VulListComponent.vue?vue&type=script&lang=ts&"
export * from "./VulListComponent.vue?vue&type=script&lang=ts&"
import style0 from "./VulListComponent.vue?vue&type=style&index=0&id=00424c8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00424c8e",
  null
  
)

export default component.exports